import owd from '../owd/owd';
import browser from '../owd/utils/browser';

export default class CustomHover extends owd.Module {
    constructor(app) {
        super(app);

        this.cursor = document.getElementById('cursor');

        this.injected = false;
        this.isSupported = !browser.isIOS() && !browser.isIOSChrome() && !browser.isIOSFirefox() && !browser.isAndroid();
        this.isEnabled = !!this.isSupported;

        this.elementEnterMove = this.elementEnterMove.bind(this);
        this.elementLeave = this.elementLeave.bind(this);
        this.elementModifierChanged = this.elementModifierChanged.bind(this);

        this.isEnabled = this.cursor != null

        if (this.isEnabled) {
           
            this.bind();
        }
    }

    bind() {
        if (!this.bindOnce) {
            this.bindOnce = true;

           

            document.documentElement.addEventListener('mousemove', (e) => {
                this.show();
                this.up();

                const transform = `translate(${e.clientX + 50}px, ${e.clientY + 10}px)`;

                this.cursor.style.transform = transform;
                this.cursor.style.webkitTransform = transform;
            });

            document.body.addEventListener('touchstart', (e) => {
                this.hide();
                this.up();
            });

            document.body.addEventListener('touchend', (e) => {
                this.hide();
                this.up();
            });

            document.body.addEventListener('touchmove', (e) => {
                this.hide();
                this.up();
            });

            document.body.addEventListener('mouseout', (e) => {
                if (e.relatedTarget === null || e.relatedTarget === document.documentElement) {
                    this.hide();
                    this.up();
                }
            });

            document.documentElement.addEventListener('mousedown', (e) => {
                this.down();
            });

            document.documentElement.addEventListener('mouseup', (e) => {
                this.up();
            });

        }
    }

    down() {
        if (!this.isPressed) {
            this.cursor.classList.add('is-pressed');
            this.isPressed = true;
        }
    }

    up() {
        if (this.isPressed) {
            this.cursor.classList.remove('is-pressed');
            this.isPressed = false;
        }
    }

    disable() {
        if (this.isEnabled) {
            //document.documentElement.classList.remove('no-cursor');
            this.isEnabled = false;
            this.hide();
        }
    }

    enable() {
        if (!this.isEnabled && this.isSupported) {
            //document.documentElement.classList.add('no-cursor');
            this.bind();
            this.isEnabled = true;
        }
    }

    show() {
       
        if (!this.injected && this.isEnabled) {
             
             
            //document.body.appendChild(this.cursor);
            this.cursor.classList.add('is-visible');
            this.injected = true;
        }
    }

    hide() {
        if (this.injected) {
            //document.body.removeChild(this.cursor);
            this.cursor.classList.remove('is-visible');
            this.injected = false;
        }
    }

    elementEnterMove(e) {
        //console.log(e);

        if (e.target.dataset.cursorHover) {
            this.setMode(e.target.dataset.cursorHover);
            this.setImage(e.target.dataset.cursorId);
        }

        if (e.target.dataset.cursorTheme) {
            this.setTheme(e.target.dataset.cursorTheme);
        }

        this.currentModifier = e.target;
    }

    elementModifierChanged(e) {
        if (e.target === this.currentModifier) {
            if (e.target.dataset.cursorHover) {
                this.setMode(e.target.dataset.cursorHover);
                this.setImage(e.target.dataset.cursorId);
            }

            if (e.target.dataset.cursorTheme) {
                this.setTheme(e.target.dataset.cursorTheme);
            }
        }
    }

    elementLeave(e) {
        if (e.target.dataset.cursorHover) {
            this.resetMode();
        }

        if (e.target.dataset.cursorTheme) {
            this.resetTheme();
        }

        if (this.currentModifier === e.target) {
            this.currentModifier = null;
        }
    }

    addModifier(element) {
        element.addEventListener('mouseenter', this.elementEnterMove);
        element.addEventListener('mousemove', this.elementEnterMove);
        element.addEventListener('mouseleave', this.elementLeave);
        element.addEventListener('cursor-modifier-changed', this.elementModifierChanged);
    }

    removeModifier(element) {
        if (this.currentModifier === element) {
            this.resetMode();
            this.resetTheme();
            this.currentModifier = null;
        }

        element.removeEventListener('mouseenter', this.elementEnterMove);
        element.removeEventListener('mousemove', this.elementEnterMove);
        element.removeEventListener('mouseleave', this.elementLeave);
        element.removeEventListener('cursor-modifier-changed', this.elementModifierChanged);
    }

    setMode(mode) {
        if (this.mode !== mode) {
            this.cursor.dataset.mode = mode;
        }
    }
    setImage(id) {

        if (this.id !== id) {
            this.cursor.dataset.id = id;
          
            //this.cursor.style.setProperty("--imageid", id);
            const selector = `.article-image:nth-child(${id})`
           // console.log(selector);
            $(selector).addClass('visible')

        }
    }

    resetMode() {
        this.cursor.dataset.mode = null;
        this.cursor.dataset.id = null;
        $(`.article-image.visible`).removeClass('visible')
       
    }

    setTheme(theme) {
        if (this.theme !== theme) {
            this.cursor.dataset.theme = theme;
        }
    }

    resetTheme() {
        this.cursor.dataset.theme = null;
    }
}
